<template>
  <div :class="{ '!w-[97%]': insideComponent }" class="w-[calc(100vw-330px)] mx-[1%] relative overflow-visible no-scrollbar">
    <Menu as="div" class="absolute z-20 flex-shrink-0 mt-10 right-8">
      <transition
        enter-active-class="transition duration-100 ease-out"
        enter-from-class="transform scale-95 opacity-0"
        enter-to-class="transform scale-100 opacity-100"
        leave-active-class="transition duration-75 ease-in"
        leave-from-class="transform scale-100 opacity-100"
        leave-to-class="transform scale-95 opacity-0">
        <MenuItems
          class="absolute z-50 w-48 mx-3 mt-6 -ml-48 origin-bottom-right bg-white rounded-md shadow-lg dark:bg-dark-screen-background ring-1 ring-black ring-opacity-5 focus:outline-none">
          <MenuItem v-slot="{ active }">
            <div
              :class="[
                active ? 'bg-gray-100 dark:bg-dark-screen-background text-gray-400' : 'text-gray-700 dark:text-dark-body-text',
                ' cursor-pointer group flex items-center px-4 py-2 text-sm'
              ]"
              @click="handleEditPhaseClick(phase)">
              <Pencil class="w-5 h-5 mr-3 text-gray-400" aria-hidden="true" />
              {{ $t("Edit") }}
            </div>
          </MenuItem>
          <MenuItem v-slot="{ active }">
            <div
              :class="[
                active ? 'bg-gray-100 dark:bg-dark-screen-background text-gray-400' : 'text-gray-700 dark:text-dark-body-text',
                ' cursor-pointer group flex items-center px-4 py-2 text-sm'
              ]"
              @click="requestRemovePhase(phase, selectedJourney)">
              <Trash2 class="w-5 h-5 mr-3 text-gray-400" aria-hidden="true" />
              {{ $t("Delete") }}
            </div>
          </MenuItem>
        </MenuItems>
      </transition>
      <MenuButton
        class="absolute inline-flex items-center justify-center w-5 h-5 text-gray-400 rounded-full z-1 hover:text-gray-500 focus:outline-none focus:ring-1 focus:ring-light-brand-blue dark:focus:ring-dark-brand-blue">
        <span class="sr-only">{{ $t("Open options") }}</span>
        <EllipsisVertical class="absolute z-10 w-5 h-5" aria-hidden="true" />
      </MenuButton>
    </Menu>
    <div class="bg-white mt-2 px-10 py-5 rounded-lg border-2 relative z-10">
      <!-- <div class="w-full h-full absolute z-1 -mt-6 -ml-10 opacity-30 handle !cursor-move" /> -->
      <div class="flex items-center w-[100%]">
        <div class="w-1/4 whitespace-nowrap flex items-center space-x-3" :class="{ 'has-tooltip': phase.name.length > 20 }">
          <LoadingSpinner v-if="!phase.records_count && phase.records_count !== 0" class="relative z-10" />
          <JourneyGreenRaiseIcon v-else-if="phase.records_count_change > 0" class="relative z-10" />
          <JourneyRedFallIcon v-else-if="phase.records_count_change < 0" class="relative z-10" />

          <JourneyYellowConstantIcon v-else class="relative z-10" />
          <span
            class="inline-flex mt-12 ml-2 z-40 items-center gap-2 px-2 py-1 text-md font-medium rounded-md tooltip whitespace-nowrap bg-light-screen-background dark:bg-dark-screen-background dark:text-dark-body-text">
            {{ phase.name }}</span>

          <span class="ml-4 text-lg font-normal z-10 w-full truncate relative">
            {{ phase.name }}
          </span>
        </div>

        <div class="flex items-center justify-start w-[70%]">
          <div class="w-1/4">
            <div class="relative z-10 font-medium text-md whitespace-nowrap">
              {{ !phase.records_count && phase.records_count !== 0 ? "Loading Records in Phase..." : "Records in Phase" }}
            </div>
            <div class="flex items-center space-x-1">
              <div class="text-lg text-[#46545C] relative z-10">
                {{ phase.records_count }}
              </div>
              <div
                v-if="!(!phase.records_count && phase.records_count !== 0)"
                :class="[
                  `${
                    phase.records_count_change
                      ? phase.records_count_change > 0
                        ? 'text-green-success'
                        : 'text-red-error'
                      : 'text-status-warning-yellow'
                  } ${
                    phase.records_count_change
                      ? phase.records_count_change > 0
                        ? 'bg-green-success'
                        : 'bg-red-error'
                      : 'bg-status-warning-yellow'
                  }/10 px-2 rounded-full w-12 relative z-10  h-6 flex items-center justify-between`
                ]">
                <Minus
                  v-if="phase.records_count_change"
                  :color="phase.records_count_change < 0 ? '#F05B5B' : '#27C884'"
                  :class="[`${phase.records_count_change < 0 ? 'rotate-180' : ''} h-3 w-3 mr-1`]" />
                <div
                  v-else
                  class="w-3 h-1 mr-2 text-lg border-2 border-t-0 border-r-0 text-status-warning-yellow border-l-2-0 border-b-status-warning-yellow" />
                {{ phase.records_count_change }}
              </div>
            </div>
          </div>

          <div class="flex items-center w-full ml-20">
            <div
              v-if="$store.state.data.solid_metrics_phases[phase.id]?.filter((stat) => stat.name == `Actual value`).length"
              class="flex w-1/3">
              <div
                class="relative z-10 w-4 h-12 border-l-2"
                :class="`${
                  phase.records_count_change
                    ? phase.records_count_change > 0
                      ? 'border-green-success'
                      : 'border-red-error'
                    : 'border-status-warning-yellow'
                }`" />
              <div>
                <div class="font-medium text-md relative z-10 truncate">
                  {{ $t("Total Actual Value") }}
                </div>
                <div class="text-lg text-[#46545C] relative z-10">
                  {{ phase.solid_stats.total_actual_value ? `$${$utils.truncateNumber(phase.solid_stats.total_actual_value)}` : "-" }}
                </div>
              </div>
            </div>

            <div
              v-if="$store.state.data.solid_metrics_phases[phase.id]?.filter((stat) => stat.name == `Forecasted value`).length"
              class="flex w-1/3">
              <div
                class="relative z-10 w-4 h-12 border-l-2"
                :class="`${
                  phase.records_count_change
                    ? phase.records_count_change > 0
                      ? 'border-green-success'
                      : 'border-red-error'
                    : 'border-status-warning-yellow'
                }`" />
              <div>
                <div class="font-medium text-md relative z-10 truncate">
                  {{ $t("Total Forecasted Value") }}
                </div>
                <div class="text-lg text-[#46545C] relative z-10">
                  {{ phase.solid_stats.total_actual_value ? `$${$utils.truncateNumber(phase.solid_stats.total_actual_value)}` : "-" }}
                </div>
              </div>
            </div>

            <div v-for="stats in phase.stats" :key="stats.id" class="w-1/3 flex">
              <div
                :class="`${
                  phase.records_count_change
                    ? phase.records_count_change > 0
                      ? 'border-green-success'
                      : 'border-red-error'
                    : 'border-status-warning-yellow'
                }`"
                class="h-14 w-1 border-l-[3px] relative z-10 min-w-4" />
              <div class="w-full">
                <div class="font-medium ml-4 text-md relative z-10 truncate">
                  {{ stats.name }} <span class="italic text-gray-300" />
                </div>
                <div class="text-lg ml-4 text-[#46545C] relative z-10">
                  {{ $utils.isNotEmpty(stats.value) ? $utils.humanizeMetricValue(stats, stats.value) : " - " }}
                </div>
              </div>
            </div>
            <div
              v-if="!(!phase.records_count && phase.records_count !== 0)"
              :class="[{ 'rotate-180': expandedPhase !== phase.id }]"
              class="absolute transition-all duration-500 ease-in-out right-10 top-7.5 cursor-pointer w-9 h-9 text-center flex justify-center bg-gray-100 rounded-full border items-center"
              @click="handleExpandPhase(phase.id)">
              <ArrowUpFromLine class="w-5 h-5" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="bg-white h-0 z-0 opacity-0 transition-all ease-in-out duration-500"
      :class="[{ 'opacity-100': expandedPhase == phase.id }]"
      :style="{
        height: expandedPhase == phase.id ? (phase.records_count > 10 ? '700px' : `${phase.records_count * 10 + 500}px`) : 0
      }">
      <ObjectView
        v-if="expandedPhase == phase.id"
        :dont-load="true"
        :applied-filter="phase.filter"
        :fixed="true"
        :has-buttons="true"
        :object-type="phase.type"
        :page-reference="PAGE_REFERENCES.CUSTOMER_JOURNEYS"
        @selectedOwners="$emit('update:selectedOwners', $event)"
        @currentFilter="$emit('update:currentFilter', $event)"
        @selectedRecords="$emit('update:selectedRecords', $event)"
        @selectedGroup="$emit('update:selectedGroup', $event)" />
    </div>
  </div>
</template>

<script>
import ObjectView from "@/components/shared/object-view/ObjectView.vue"
import { PAGE_REFERENCES } from "@/store/constants/references"
import JourneyGreenRaiseIcon from "@/components/shared/icons/JourneyGreenRaiseIcon.vue"
import JourneyRedFallIcon from "@/components/shared/icons/JourneyRedFallIcon.vue"
import JourneyYellowConstantIcon from "@/components/shared/icons/JourneyYellowConstantIcon.vue"
import LoadingSpinner from "@/components/shared/LoadingSpinner.vue"
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/vue"
import { ArrowUpFromLine, Minus, Trash2, EllipsisVertical, Pencil } from "lucide-vue-next"
import { ALL_EMITTERS } from "@/store/constants/all_emitters"

export default {
  components: {
    Trash2,
    Pencil,
    Menu,
    MenuButton,
    MenuItem,
    MenuItems,
    ObjectView,
    JourneyGreenRaiseIcon,
    JourneyRedFallIcon,
    JourneyYellowConstantIcon,
    ArrowUpFromLine,
    Minus,
    LoadingSpinner,
    EllipsisVertical
  },
  props: {
    insideComponent: {
      type: Boolean,
      default: false
    },
    phase: {
      type: Object,
      required: true
    },
    journeys: {
      type: Array,
      required: true
    },
    selectedJourney: {
      type: Object,
      required: true
    },
    expandedPhase: {
      type: String,
      required: true
    }
  },
  emits: ["update:expandedPhase", "update:selectedOwners", "update:currentFilter", "update:selectedRecords", "update:selectedGroup"],
  data() {
    return {
      PAGE_REFERENCES
    }
  },
  watch: {},

  created() {},

  methods: {
    handleExpandPhase(id) {
      this.$emit("update:expandedPhase", this.expandedPhase == id ? "" : id)
    },
    handleEditPhaseClick(phase) {
      this.$emitter.emit(ALL_EMITTERS.EDIT_PHASE, {
        journeys: this.journeys,
        phase,
        selected_journey: this.selectedJourney
      })
    },
    requestRemovePhase(phase) {
      this.$emitter.emit(ALL_EMITTERS.DELETE_PHASE, {
        phase,
        selected_journey: this.selectedJourney
      })
    }
  }
}
</script>
